import {Navigable} from '@synako/halitrek';
import {SyntheseEGalimDesc} from 'api-types/ffconnect-hal';
import {useTranslation} from 'react-i18next';
import {BlueButton} from '@/components/Button/BlueButton';
import {getModeFromUrl} from '@/utils/appMode';

/** Bouton d'export de la synthèse ÉGalim au format Excel (.xlsx) */
export const EgalimExportButton: React.FC<{
  syntheseNav: Navigable<SyntheseEGalimDesc>;
}> = ({syntheseNav}) => {
  const {t} = useTranslation();

  const handleExport = () => {
    // La synthèse est déjà en cache (affichée sur la page), on résout le lien directement
    const exportNav = syntheseNav
      .follow('exporter-synthese-egalim')
      .resolveCache();
    if (exportNav) {
      // window.open déclenche une navigation top-level qui ne transmet pas le
      // header x-client-app posé par halitrek. On passe le mode via le query
      // param client_app pour que le back lise le bon cookie de session
      // (sinon il retombe sur le cookie 'client' — 403 en mode assistance).
      const url = new URL(exportNav.uri, window.location.origin);
      url.searchParams.set('client_app', getModeFromUrl());
      window.open(url.toString(), '_blank');
    }
  };

  return (
    <BlueButton
      onClick={handleExport}
      texte={t('egalim.exporter')}
    />
  );
};
